import { type GuestUserParams } from '@/features/account/services/GuestUser/types'
import { type RequestCookies } from '@shared/request_type'
import { guestAddressCookie, guestStoreCookie } from '@/features/account/services/GuestUser/cookies'

export const getGuestStoreParams = ({ guestStore, guestAddress }: GuestUserParams) => ({
  // adding user_id with the value 0 so that it can be destructured
  // within useStoreParams even though a guest user does not have user_id
  user_id: 0,
  zip: guestAddress?.zip_code ?? '',
  store_id: guestStore?.id ?? null,
  metro_id: guestStore?.metro_id ?? null,
  store_location_id: guestStore?.store_location_id ?? null,
})

export const getGuestStoreParamsSSR = (cookies: RequestCookies) => {
  const guestData: GuestUserParams = {
    guestStore: guestStoreCookie.from(cookies),
    guestAddress: guestAddressCookie.from(cookies),
  }
  return {
    ...guestData,
    guestStoreParams: getGuestStoreParams(guestData),
  }
}
